import React from "react";

interface ICellProps {
    className?: string,
    children: React.ReactNode
}

const Cell: React.FC<ICellProps> = ({
    className,
    children
}) => {
    return (
        <th className={`${className}`}>
            {children}
        </th>
    )
}

export default Cell;